<template>
    <div :key="key" class="cover-select-custom">
        <span 
            class="cover-label" 
            @click.stop="handleCoverClick" 
            v-html="name.replace(/:|：/, '')" />
        <el-select
            v-model="_value"
            :ref="ref"
            :placeholder="placeholder"
            v-bind="$attrs"
            style=" width: 70px "
            v-on="$listeners"
        >
            <el-option
                v-for="option in options"
                :key="option.value"
                v-bind="option"/>
        </el-select>
        <span v-show="~name.indexOf(':') || ~name.indexOf('：')" class="form-item-name form-item-comma">：</span>
    </div>
</template>

<script>
export default {
  name: "CoverselectCustom",
  
  inheritAttrs: false,

  props: {
    name: {
      default: "",
      type: String
    },
    
    value: {
      default: "",
      type: [String, Number]
    },

    options: {
      type: Array,
      require: true,
      default: () => []
    },

    placeholder: {
      type: String,
      default: "请选择"
    }
  },

  data() {
    return {
      key: `SelectCustomID-${Math.random()
        .toString(36)
        .slice(2)}`,
      ref: "cover-select",

      visible: false
    };
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },

  methods: {
    handleCoverClick() {
      const visible = this.visible;
      this.$refs[this.ref].visible = visible;
      this.$refs[this.ref].toggleMenu();
      this.visible = !this.visible;
    }
  }
};
</script>

<style lang="scss">
.cover-select-custom {
  display: inline-block;
  position: relative;
  .cover-label {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 25px;
    z-index: 1;
    background: #fff;
    font-size: 14px;
    line-height: 30px;
    width: auto;
    cursor: pointer;
    &:hover {
      color: #233213;
    }
  }
  .el-select .el-input .el-input__inner {
    border-color: transparent;
    &:focus {
      border-color: transparent;
    }
  }
  .form-item-name {
    width: auto;
    position: absolute;
    top: 0;
    right: 0;
  }
  .form-item-comma{
    padding: 0;
  }
}
</style>
